export const Languages = {
    ko : "한국어",
    en : "English",
}